import React from "react";
import { Grid } from "@material-ui/core";
import SalesForecastCurrentQuarterTable from "../SalesForecastCurrentQuarterTable";

const SalesForecastCurrentQtrPaper = ({
  classes,
  paperTitle,
  salesForecastCurrentQuarterData,
  isSalesForecastCurrentQuarterLoading,
  asOfDateLabel,
  handleChangeLocation,
  currencySymbol,
  forecastOpportunityColumns,
}) => {

  return (
    <Grid item xs={12}>
      <SalesForecastCurrentQuarterTable
        classes={classes}
        data={salesForecastCurrentQuarterData}
        isLoading={isSalesForecastCurrentQuarterLoading}
        asOfDateLabel={asOfDateLabel}
        handleChangeLocation={handleChangeLocation}
        currencySymbol={currencySymbol}
        forecastOpportunityColumns={forecastOpportunityColumns}
      />
    </Grid>
  );
};

export default SalesForecastCurrentQtrPaper;
